import React from "react";
import { Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiPython,
  DiGit,
  DiPhp,
  DiJava,
  DiAngularSimple,
  DiCss3,
  DiHtml5,
  DiSass,
  DiRuby,
} from "react-icons/di";
import {
  SiLaravel,
  SiMongodb,
  SiMysql,
  SiNextdotjs,
  SiTypescript,
  SiPostgresql,
  SiSupabase,
  SiVuedotjs,
  SiVite,
  SiUnity,
  SiCplusplus,
  SiPrisma,
  SiExpress,
  SiDotnet,
  SiOdoo,
  SiUnrealengine,
  SiTailwindcss,
  SiBootstrap,
  SiSvelte,
  SiDjango,
  SiFlask,
  SiGo,
  SiRust,
  SiKotlin,
  SiSwift,
  SiFlutter,
  SiDocker,
  SiKubernetes,
  SiRedis,
  SiGraphql,
  SiJquery,
  SiDart,
  SiSqlite,
  SiNuxt,
  SiNestjs,
  SiFastapi,
  SiSpringboot,
  SiC,
  SiWebpack,
  SiRedux,
  SiMui,
  SiElasticsearch,
  SiFirebase,
  SiRubyonrails,
  SiElectron,
  SiThreedotjs,
  SiAstro,
  SiApachekafka,
  SiRabbitmq,
  SiNginx,
  SiStyledcomponents,
  SiReactquery,
  SiZod,
  SiDrizzle,
  SiApachecassandra,
  SiMariadb,
  SiGatsby,
  SiEmberdotjs,
  SiPug,
  SiHandlebarsdotjs,
  SiEjs,
  SiSocketdotio,
  SiJsonwebtokens,
  SiStrapi,
  SiSanity,
  SiContentful,
  SiGhost,
  SiWordpress,
  SiShopify,
  SiWoo,
  SiBigcommerce,
  SiOpenai,
  SiHuggingface,
  SiLangchain,
  SiOpencv,
  SiScikitlearn,
  SiTensorflow,
  SiPytorch,
  SiStreamlit,
  SiJupyter,
  SiGooglecolab,
  SiPandas,
  SiNumpy,
  SiKeras,
  SiApachespark,
  SiMlflow,
  SiAndroidstudio,
  SiXcode,
  SiGodotengine,
  SiSolidity,
  SiWeb3Dotjs,
  SiIpfs,
} from "react-icons/si";
import { FaAws } from "react-icons/fa";
import { VscAzure } from "react-icons/vsc";
import { MdSmartToy } from "react-icons/md";
import { BsCloudFill, BsDatabase } from "react-icons/bs";
import { TbBrandCSharp, TbBrandReactNative } from "react-icons/tb";
import { GrOracle } from "react-icons/gr";

const sections = [
  {
    title: "Frontend Development",
    items: [
      { icon: <DiHtml5 />, name: "HTML5", url: "https://developer.mozilla.org/en-US/docs/Web/HTML" },
      { icon: <DiCss3 />, name: "CSS3", url: "https://developer.mozilla.org/en-US/docs/Web/CSS" },
      { icon: <DiSass />, name: "Sass", url: "https://sass-lang.com/documentation" },
      { icon: <DiJavascript1 />, name: "JavaScript", url: "https://developer.mozilla.org/en-US/docs/Web/JavaScript" },
      { icon: <SiTypescript />, name: "TypeScript", url: "https://www.typescriptlang.org/docs" },
      { icon: <SiJquery />, name: "jQuery", url: "https://api.jquery.com" },
      { icon: <DiReact />, name: "React.js", url: "https://react.dev" },
      { icon: <SiNextdotjs />, name: "Next.js", url: "https://nextjs.org/docs" },
      { icon: <SiVuedotjs />, name: "Vue.js", url: "https://vuejs.org/guide" },
      { icon: <SiNuxt />, name: "Nuxt.js", url: "https://nuxt.com/docs" },
      { icon: <DiAngularSimple />, name: "Angular", url: "https://angular.dev/overview" },
      { icon: <SiSvelte />, name: "Svelte", url: "https://svelte.dev/docs" },
      { icon: <SiAstro />, name: "Astro", url: "https://docs.astro.build" },
      { icon: <SiGatsby />, name: "Gatsby", url: "https://www.gatsbyjs.com/docs" },
      { icon: <SiEmberdotjs />, name: "Ember.js", url: "https://emberjs.com/api" },
      { icon: <SiRedux />, name: "Redux", url: "https://redux.js.org" },
      { icon: <SiReactquery />, name: "React Query", url: "https://tanstack.com/query/latest" },
      { icon: <SiZod />, name: "Zod", url: "https://zod.dev" },
      { icon: <SiVite />, name: "Vite", url: "https://vite.dev/guide" },
      { icon: <SiWebpack />, name: "Webpack", url: "https://webpack.js.org/concepts" },
      { icon: <SiTailwindcss />, name: "Tailwind CSS", url: "https://tailwindcss.com/docs" },
      { icon: <SiBootstrap />, name: "Bootstrap", url: "https://getbootstrap.com/docs" },
      { icon: <SiMui />, name: "Material UI", url: "https://mui.com/material-ui/getting-started" },
      { icon: <SiStyledcomponents />, name: "Styled Comp.", url: "https://styled-components.com/docs" },
      { icon: <SiThreedotjs />, name: "Three.js", url: "https://threejs.org/docs" },
      { icon: <SiElectron />, name: "Electron", url: "https://www.electronjs.org/docs" },
      { icon: <SiPug />, name: "Pug", url: "https://pugjs.org/api/getting-started.html" },
      { icon: <SiHandlebarsdotjs />, name: "Handlebars", url: "https://handlebarsjs.com/guide" },
      { icon: <SiEjs />, name: "EJS", url: "https://ejs.co" },
    ],
  },
  {
    title: "Backend Development",
    items: [
      { icon: <DiNodejs />, name: "Node.js", url: "https://nodejs.org/en/docs" },
      { icon: <SiExpress />, name: "Express.js", url: "https://expressjs.com" },
      { icon: <SiNestjs />, name: "NestJS", url: "https://docs.nestjs.com" },
      { icon: <DiPython />, name: "Python", url: "https://docs.python.org/3" },
      { icon: <SiDjango />, name: "Django", url: "https://docs.djangoproject.com" },
      { icon: <SiFlask />, name: "Flask", url: "https://flask.palletsprojects.com" },
      { icon: <SiFastapi />, name: "FastAPI", url: "https://fastapi.tiangolo.com" },
      { icon: <DiPhp />, name: "PHP", url: "https://www.php.net/docs.php" },
      { icon: <SiLaravel />, name: "Laravel", url: "https://laravel.com/docs" },
      { icon: <DiJava />, name: "Java", url: "https://docs.oracle.com/en/java" },
      { icon: <SiSpringboot />, name: "Spring Boot", url: "https://spring.io/projects/spring-boot" },
      { icon: <SiDotnet />, name: ".NET", url: "https://learn.microsoft.com/en-us/dotnet" },
      { icon: <SiCplusplus />, name: "C++", url: "https://cplusplus.com/doc" },
      { icon: <TbBrandCSharp />, name: "C#", url: "https://learn.microsoft.com/en-us/dotnet/csharp" },
      { icon: <SiC />, name: "C", url: "https://devdocs.io/c" },
      { icon: <SiGo />, name: "Go", url: "https://go.dev/doc" },
      { icon: <SiRust />, name: "Rust", url: "https://doc.rust-lang.org/book" },
      { icon: <SiKotlin />, name: "Kotlin", url: "https://kotlinlang.org/docs" },
      { icon: <DiRuby />, name: "Ruby", url: "https://www.ruby-lang.org/en/documentation" },
      { icon: <SiRubyonrails />, name: "Rails", url: "https://rubyonrails.org" },
      { icon: <SiGraphql />, name: "GraphQL", url: "https://graphql.org/learn" },
      { icon: <SiSocketdotio />, name: "Socket.io", url: "https://socket.io/docs" },
      { icon: <SiJsonwebtokens />, name: "JWT", url: "https://jwt.io/introduction" },
      { icon: <SiOdoo />, name: "Odoo", url: "https://www.odoo.com/documentation" },
    ],
  },
  {
    title: "Database & Storage",
    items: [
      { icon: <SiMysql />, name: "MySQL", url: "https://dev.mysql.com/doc" },
      { icon: <SiPostgresql />, name: "PostgreSQL", url: "https://www.postgresql.org/docs" },
      { icon: <SiMongodb />, name: "MongoDB", url: "https://www.mongodb.com/docs" },
      { icon: <SiRedis />, name: "Redis", url: "https://redis.io/docs" },
      { icon: <SiSqlite />, name: "SQLite", url: "https://www.sqlite.org/docs.html" },
      { icon: <SiMariadb />, name: "MariaDB", url: "https://mariadb.com/kb/en/documentation" },
      { icon: <SiApachecassandra />, name: "Cassandra", url: "https://cassandra.apache.org/doc" },
      { icon: <SiElasticsearch />, name: "Elasticsearch", url: "https://www.elastic.co/guide" },
      { icon: <BsDatabase />, name: "DynamoDB", url: "https://docs.aws.amazon.com/dynamodb" },
      { icon: <SiFirebase />, name: "Firebase", url: "https://firebase.google.com/docs" },
      { icon: <SiSupabase />, name: "Supabase", url: "https://supabase.com/docs" },
      { icon: <SiPrisma />, name: "Prisma", url: "https://www.prisma.io/docs" },
      { icon: <SiDrizzle />, name: "Drizzle", url: "https://orm.drizzle.team/docs/overview" },
    ],
  },
  {
    title: "Mobile Development",
    items: [
      { icon: <TbBrandReactNative />, name: "React Native", url: "https://reactnative.dev/docs/getting-started" },
      { icon: <SiFlutter />, name: "Flutter", url: "https://docs.flutter.dev" },
      { icon: <SiDart />, name: "Dart", url: "https://dart.dev/guides" },
      { icon: <SiSwift />, name: "Swift", url: "https://www.swift.org/documentation" },
      { icon: <SiKotlin />, name: "Kotlin", url: "https://kotlinlang.org/docs" },
      { icon: <SiAndroidstudio />, name: "Android Studio", url: "https://developer.android.com/studio" },
      { icon: <SiXcode />, name: "Xcode", url: "https://developer.apple.com/xcode" },
    ],
  },
  {
    title: "AI / ML & Data Science",
    items: [
      { icon: <SiOpenai />, name: "OpenAI", url: "https://platform.openai.com/docs" },
      { icon: <SiHuggingface />, name: "Hugging Face", url: "https://huggingface.co/docs" },
      { icon: <SiLangchain />, name: "LangChain", url: "https://docs.langchain.com" },
      { icon: <SiTensorflow />, name: "TensorFlow", url: "https://www.tensorflow.org/learn" },
      { icon: <SiPytorch />, name: "PyTorch", url: "https://pytorch.org/docs" },
      { icon: <SiKeras />, name: "Keras", url: "https://keras.io/api" },
      { icon: <SiOpencv />, name: "OpenCV", url: "https://docs.opencv.org" },
      { icon: <SiScikitlearn />, name: "Scikit-learn", url: "https://scikit-learn.org/stable/documentation.html" },
      { icon: <SiPandas />, name: "Pandas", url: "https://pandas.pydata.org/docs" },
      { icon: <SiNumpy />, name: "NumPy", url: "https://numpy.org/doc" },
      { icon: <SiApachespark />, name: "Spark", url: "https://spark.apache.org/docs/latest" },
      { icon: <SiMlflow />, name: "MLflow", url: "https://mlflow.org/docs/latest" },
      { icon: <SiStreamlit />, name: "Streamlit", url: "https://docs.streamlit.io" },
      { icon: <SiJupyter />, name: "Jupyter", url: "https://docs.jupyter.org" },
      { icon: <SiGooglecolab />, name: "Google Colab", url: "https://colab.research.google.com" },
      { icon: <MdSmartToy />, name: "AI Agent", url: "https://docs.anthropic.com" },
    ],
  },
  {
    title: "Cloud & DevOps",
    items: [
      { icon: <SiDocker />, name: "Docker", url: "https://docs.docker.com" },
      { icon: <SiKubernetes />, name: "Kubernetes", url: "https://kubernetes.io/docs" },
      { icon: <FaAws />, name: "AWS", url: "https://docs.aws.amazon.com" },
      { icon: <VscAzure />, name: "Azure", url: "https://learn.microsoft.com/en-us/azure" },
      { icon: <BsCloudFill />, name: "GCP", url: "https://cloud.google.com/docs" },
      { icon: <GrOracle />, name: "Oracle Cloud", url: "https://docs.oracle.com/en/cloud" },
      { icon: <SiNginx />, name: "Nginx", url: "https://nginx.org/en/docs" },
      { icon: <SiApachekafka />, name: "Kafka", url: "https://kafka.apache.org/documentation" },
      { icon: <SiRabbitmq />, name: "RabbitMQ", url: "https://www.rabbitmq.com/docs" },
      { icon: <DiGit />, name: "Git", url: "https://git-scm.com/doc" },
    ],
  },
  {
    title: "CMS & E-Commerce",
    items: [
      { icon: <SiWordpress />, name: "WordPress", url: "https://developer.wordpress.org" },
      { icon: <SiShopify />, name: "Shopify", url: "https://shopify.dev/docs" },
      { icon: <SiWoo />, name: "WooCommerce", url: "https://woocommerce.com/documentation" },
      { icon: <SiBigcommerce />, name: "BigCommerce", url: "https://developer.bigcommerce.com/docs" },
      { icon: <SiStrapi />, name: "Strapi", url: "https://docs.strapi.io" },
      { icon: <SiSanity />, name: "Sanity", url: "https://www.sanity.io/docs" },
      { icon: <SiContentful />, name: "Contentful", url: "https://www.contentful.com/developers/docs" },
      { icon: <SiGhost />, name: "Ghost", url: "https://ghost.org/docs" },
    ],
  },
  {
    title: "Game Dev & Web3",
    items: [
      { icon: <SiUnity />, name: "Unity", url: "https://docs.unity.com" },
      { icon: <SiUnrealengine />, name: "Unreal Engine", url: "https://docs.unrealengine.com" },
      { icon: <SiGodotengine />, name: "Godot", url: "https://docs.godotengine.org" },
      { icon: <SiSolidity />, name: "Solidity", url: "https://docs.soliditylang.org" },
      { icon: <SiWeb3Dotjs />, name: "Web3.js", url: "https://docs.web3js.org" },
      { icon: <SiIpfs />, name: "IPFS", url: "https://docs.ipfs.tech" },
    ],
  },
];

function Techstack() {
  return (
    <div>
      {sections.map((section, idx) => (
        <div key={idx} style={{ marginBottom: "30px" }}>
          <h2 className="tech-section-title">{section.title}</h2>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "10px",
              paddingBottom: "20px",
            }}
          >
            {section.items.map((skill, index) => (
              <a
                href={skill.url}
                target="_blank"
                rel="noopener noreferrer"
                className="tech-icons"
                key={index}
                title={skill.name}
                style={{ textDecoration: "none", color: "inherit" }}
              >
                {skill.icon}
                <span className="tech-icon-name">{skill.name}</span>
              </a>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Techstack;
